import { motion, type Transition, useAnimate } from 'motion/react'
import { useEffect } from 'react'

export function ArrowRight({
  className,
  delay = 0,
  onClick,
}: {
  className?: string
  delay?: number
  onClick?: () => void
}) {
  const [scope, animate] = useAnimate()

  useEffect(() => {
    async function sequence() {
      // Fade in
      await animate(scope.current, { opacity: 1 }, { duration: 1, delay })
      // Infinite bounce
      const bounce: Transition = {
        duration: 3.7,
        ease: 'easeInOut',
        repeat: Infinity,
      }
      animate(scope.current, { x: [0, 6, 0], opacity: [1, 0, 1] }, bounce)
    }
    sequence()
  }, [animate, delay, scope])

  return (
    <motion.svg
      ref={scope}
      className={className}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial={{ opacity: 0 }}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : undefined }}
    >
      <path
        d="M25.2525 10.3775L35.875 21L25.2525 31.6225"
        stroke="white"
        strokeWidth="2.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.125 21H35.5775"
        stroke="white"
        strokeWidth="2.625"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  )
}
